export default __webpack_public_path__ + "static/media/31.89c674a1.png";